$.fn.RepeaterFieldRow = function(_field)
{
	// Instance
	if ($(this).data('repeaterFieldRow')){
		return $(this).data('repeaterFieldRow');
	}
	
	var _row = this;
	_row.field = _field;
	_row.data('repeaterFieldRow', _row);
	
	_row.el = {
		button: {
			remove: _row.find('.repeater-field__remove')
		}
	};
	
	_row.delete = function()
	{
		_row.field.remove_row(_row);
	};
	
	_row.val = function(new_values)
	{
		if (new_values != undefined){
			for (var name in new_values) {
				if (new_values.hasOwnProperty(name)) {
					var input = _row.find('[name=' + name + ']');
					if (input.attr("type") == "checkbox"){
						input.prop("checked", new_values[name] == 1).trigger('change');
					} else {
						input.val(new_values[name]).trigger('change');
					}
				}
			}
		} else {
			var values = {}, has_values = false;
			_field.names.forEach(function(name, index){
				var input = _row.find('[name=' + name + ']');
				var value = input.val();
				if (input.attr("type") == "checkbox"){
					value = input.prop("checked") ? "on" : "off";
				}
				if (value){ has_values = true; }
				values[name] = value;
			});
			return has_values ? values : false;
		}
	};
	
	return function()
	{
		_row.removeClass('template');
		_row.el.button.remove.on('click', _row.delete);
		_row.find('select').each(function(){
			if ($(this).hasClass('select-search')){
				$(this).select2({
					language: "fr"
				});
			} else if ($(this).hasClass("select")){
				$(this).selectpicker();
			}
		});
		_row.find(':input').on("change", function(){
			_row.field.trigger('update');
		})
		return _row;
	}();
};

$.fn.RepeaterField = function()
{
	// Instance
	if ($(this).data('repeaterField')){
		return $(this).data('repeaterField');
	}
	
	var _field = this;
	_field.el = {
		button: {
			add: _field.find('.repeater-field__add'),
		},
		container: _field.find('.repeater-field__rows'),
		template: _field.find('.repeater-field__row.template')
	};
	_field.rows = [];
	_field.names = [];
	$(this).data('repeaterField', _field);
	
	_field.add_row = function(row_values)
	{
		var newRow = _field.el.template.clone().RepeaterFieldRow(_field);
		if (row_values != undefined){
			newRow.val(row_values);
		}
		_field.el.container.append(newRow);
		_field.rows.push(newRow);
		_field.trigger("update");
		return newRow;
	};
	
	_field.remove_row = function(row)
	{
		var index = _field.rows.indexOf(row);
		if (index >= 0){
			_field.rows.splice(index, 1);
		}
		row.remove();
		_field.trigger("update");
	};
	
	_field.val = function()
	{
		var values = [];
		_field.rows.forEach(function(row, index){
			var row_values = row.val();
			if (row_values){
				values.push(row_values);
			}
		});
		return JSON.stringify(values);
	};
	
	return function()
	{
		_field.el.template.find(':input').each(function(){
			var fieldname = $(this).attr("name");
			if (fieldname != undefined){
				_field.names.push(fieldname);
			}
		});
		if (_field.data('value')){
			var value = _field.data('value');
			value.forEach(function(row, index){
				_field.add_row(row);
			});
		}
		_field.el.button.add.on('click', _field.add_row);
		_field.data('repeater_field', _field);
		return _field;
	}();
};